import { render, staticRenderFns } from "./PersonaCrud.vue?vue&type=template&id=480888c6"
import script from "./PersonaCrud.vue?vue&type=script&lang=js"
export * from "./PersonaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports